import { useState, useEffect } from 'react';

export const useEvents = (adEventsService) => {
  const [events, setEvents] = useState(null);
  const [subCategories, setSubCategories] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      const [data] = await adEventsService.getAllEvents({
        page: -1,
        skip: -1,
      });
      const categories = await adEventsService.getEventsSubCategories();
      setEvents(data);
      setSubCategories(categories);
    };

    fetchEvents();
  }, [adEventsService]);

  return {
    events,
    subCategories,
  };
};
